import React from 'react'
import './styles.scss';
import Element from './Element'

const {article, publisherItems} = window.__STATE__ || {article: null, publisherItems: []};

export default () => (
    <Element publisher={article.publisher} relatedItems={publisherItems} />
)
